export default "__VITE_ASSET__BqpBkqHo__"